// import styles from "./TacFrame.module.scss";
import React from "react";
import _ from "lodash";

import Rendition from "../../types/Rendition";
import Img from "../Img";
import { DownloadIcon } from "../Icons/Download";

const BIG_SIZE = "(max-width: 420px) 90vw, 80vw";
const SMALL_SIZE = "(max-width: 420px) 95vw, 35vw";

export interface TacFrameProps {
    renditions: Rendition[];
    filename: string;
    big: boolean;
    options: boolean;
    onMaximize: () => void;
    onMouseOver: () => void;
    onClick: () => void;
    galleryID: number;
    tacID: number;
}

export const TacFrame = (props: TacFrameProps) => {
    const sorted = _.sortBy(props.renditions, ['size']);
    const best = _.last(sorted).url;
    const base = best && _.last(best.split("/"))
    const optionsStyle = {
        display: props.options ? "block" : "none",
    };
    const href =`/api/v2/download/galleries/${props.galleryID}/tacs/${props.tacID}`

    return (
        <div className="frame" onMouseOver={props.onMouseOver} onClick={props.onClick}>
            <div className="frame-container">
                <Img
                    className="tac-pic"
                    renditions={props.renditions}
                    size={props.big ? BIG_SIZE : SMALL_SIZE} />
            </div>
            <div className="frame-top"></div>
            <div className="frame-right"></div>
            <div className="frame-bottom"></div>
            <div className="frame-left"></div>
            <div className="frame-tl"></div>
            <div className="frame-tr"></div>
            <div className="frame-br"></div>
            <div className="frame-bl"></div>

            {!props.big && (
                <div className="image-option-menu" style={optionsStyle}>
                    <a className="download-img" href={href} download={props.filename}>
                        <DownloadIcon /> Download
                    </a>
                    <img
                        className="view-full-screen"
                        onClick={props.onMaximize}
                        src="https://tacboard.com/img/full-screen.svg"
                        alt="maximize icon" />
                </div>
            )}
        </div>
    );
}

export default TacFrame;
